import TechText from '@/components/ui/TechText'

const links = [
  { label: 'PM-Kit', href: 'https://github.com/kv0906/pm-kit' },
  { label: 'GitHub', href: 'https://github.com/kv0906' },
]

export function Footer() {
  return (
    <footer className="border-t border-vibe-border py-12" aria-label="Site footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-8 h-[180px] border-b border-vibe-border sm:h-[260px] lg:h-[360px]">
          <TechText
            text="WILL TRAN"
            fontFamily="Geist"
            fontWeight={600}
            fontSize={220}
            className="text-text-heading"
            accentColor="#f34e3f"
            reveal="letter"
            dashLength={4}
            dashGap={2}
            specks={15}
            intro="none"
            clickKick
            guides={false}
          />
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <span className="font-mono text-lg text-text-primary">
              Will <span className="text-accent-primary">Tran</span>
            </span>
          </a>

          {/* Links with border separators */}
          <div className="flex items-center">
            {links.map((link, index) => (
              <a
                key={link.label}
                href={link.href}
                className={`
                  font-mono text-small text-text-secondary hover:text-accent-primary transition-colors
                  px-4
                  ${index < links.length - 1 ? 'border-r border-vibe-border' : ''}
                `}
                target={link.href.startsWith('http') ? '_blank' : undefined}
                rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                aria-label={link.href.startsWith('http') ? `${link.label} (opens in new tab)` : undefined}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Copyright */}
          <p className="font-mono text-tiny text-text-muted">
            © {new Date().getFullYear()} Will Tran
          </p>
        </div>
      </div>
    </footer>
  )
}
